import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent, DamItemVersion, DocumentExif, FileService, InputFile} from 'compob2b-libs';
import {catchError, take, tap} from 'rxjs/operators';
import {translations} from '../../../../../../../../environments/translations.ru';
import {DamService} from '../../../../../dam.service';
import {DamItemVersionsRenameComponent} from '../../../../dam-item-versions-rename/dam-item-versions-rename.component';
import {DamItemVersionTypeCountWSelected} from '../../../../dam-table/dam-catalog.component';

interface DocumentFile {
  enabled: boolean;
  header: string;
  fileInput: File;
}

@Component({
  selector: 'app-dam-item-versions',
  templateUrl: './dam-item-versions.component.html',
  styleUrls: ['./dam-item-versions.component.scss'],
  standalone: false
})
export class DamItemVersionsComponent extends BaseComponent {
  @Input() modelId: string;
  @Input() write: boolean = false;
  @Input() currentVersion = null;
  @Input() versionsHistory: DamItemVersion[] = [];
  @Input() damItemVersions: DamItemVersion[] = [];
  @Input() fileExtensions: DamItemVersionTypeCountWSelected[] = [];
  @Output() versionSelectEvent = new EventEmitter<DamItemVersion>();

  documentExifList: DocumentExif[] = [];
  exifIid: number;
  clickedDamItemVersion: DamItemVersion = null;

  constructor(protected readonly fileService: FileService,
              protected readonly damService: DamService) {
    super();
  }

  getExif(damItemVersionId: number, iid: number) {
    if (this.exifIid === iid) {
      return;
    }
    this.exifIid = iid;
    this.loading = true;

    this.compoApiService.get<DocumentExif[]>('/dam/exif-data-of-version/' + damItemVersionId)
      .pipe(take(1))
      .subscribe(response => {
        this.loading = false;
        this.documentExifList = response.data;
        this.cdr.detectChanges();
      });
  }

  getHistory(version: DamItemVersion) {
    this.loading = true;
    this.clickedDamItemVersion = version;
    this.compoApiService.get<DamItemVersion[]>('/dam/' + version.id + '/versions-history').subscribe(response => {
      this.versionsHistory = response.data;
      this.loading = false;
      this.cdr.detectChanges();
    });
  }

  filterSidebarFilter($event) {
    this.damItemVersions.forEach(item => {
      if ($event.srcElement.value != '') {
        item.hideExpression = !item.header.toUpperCase().includes($event.srcElement.value.toUpperCase());
      } else {
        item.hideExpression = false;
      }
    });
    this.cdr.detectChanges();
  }

  selectVersion(damItemVersion: DamItemVersion) {
    this.versionSelectEvent.emit(damItemVersion);
  }

  isAllExtensionsSelected = false;

  onFileExtensionToggle(index: number): void {
    this.fileExtensions[index].selected = !this.fileExtensions[index].selected;
    this.isAllExtensionsSelected = this.allItemsSelected(this.fileExtensions);
    this.filterVersions(this.damItemVersions);
  }

  allItemsSelected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => item?.selected));
  }

  allItemsUnselected<T extends { selected: boolean }>(items: T[]): boolean {
    return (items.every(item => !item?.selected));
  }

  filterVersions(damItemVersions: DamItemVersion[]) {
    if (this.allItemsUnselected(this.fileExtensions)) {
      return damItemVersions;
    }

    const selectedExtensionsNames: string[] = this.fileExtensions.map(extension => {
      if (extension.selected) {
        return extension.typeOfFile;
      }
    }).filter(Boolean);

    return damItemVersions.filter((version: DamItemVersion) => {
      return selectedExtensionsNames.includes(version.mimeType);
    });
  }

  drop(event: CdkDragDrop<DamItemVersion[]>) {
    if (this.write) {
      console.log('event', event);
      console.log('event.previousIndex', event.previousIndex);
      console.log('event.currentIndex', event.currentIndex);
      moveItemInArray(this.damItemVersions, event.previousIndex, event.currentIndex);
      console.log('damItemVersions after sort', this.damItemVersions);
      let sortedDamItemVersionIds = [];
      this.damItemVersions.forEach(item => {
        sortedDamItemVersionIds.push(item.id);
      });
      console.log('damItemVersions IDS after sort', sortedDamItemVersionIds);

      this.loading = true;
      this.compoApiService.post('/dam/item-versions-sort/' + this.modelId, {
          sortedDamItemVersionIds
        })
        .pipe(
          take(1),
          catchError(error => this.handleError(error)),
          tap(_ => this.loading = false)
        ).subscribe();
    }
  }

  download(id: number, header: string): void {
    this.fileService.downloadUrl('/dam/download/' + id)
      .subscribe(response => {
        FileService.saveAs(response, header);
      });
  }

  makeActual(damItemVersionId: number) {
    this.loading = true;
    this.compoApiService.get('/dam/change-actual-dam-version/' + this.currentVersion.id + '/' + damItemVersionId)
      .pipe(take(1), catchError(error => this.handleError(error))).subscribe(_ => {
      window.location.reload();
    });
  }

  modalRename(version: DamItemVersion) {
    this.windowService.open(DamItemVersionsRenameComponent, {
      context: {version: version},
      title: translations.dam.rename,
    }).onClose.subscribe(version => {
      if (version) {
        this.loading = true;
        this.compoApiService.get<DamItemVersion[]>('/dam/' + this.modelId + '/versions').subscribe(response => {
          this.loading = false;
          this.damItemVersions = response.data;
          this.selectVersion(version);
          this.cdr.detectChanges();
        });
      }
    });
  }

  onUpload(files: InputFile[]) {
    this.loading = true;
    this.compoApiService
      .postForm<DocumentFile, string>('/dam/upload-version-history/' + this.clickedDamItemVersion.id, {enabled: true, header: files[0].file.name, fileInput: files[0].file})
      .pipe(
        take(1),
        catchError(error => this.handleError(error)),
        tap(response => {
          this.loading = false;

          const message = this.damService.getUploadError(response);
          if (message) {
            this.warningToast(message);
          } else {
            this.getHistory(this.clickedDamItemVersion);
            this.cdr.detectChanges();
          }
        }),
      ).subscribe();
  }

  protected readonly translations = translations
}
